var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#4DA44E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4671 22.8962C32.0359 22.8962 32.4152 22.517 32.4152 21.9481C32.4152 21.3792 32.0359 21 31.4671 21H27.6747C27.1058 21 26.7266 21.3792 26.7266 21.9481C26.7266 22.517 27.1058 22.8962 27.6747 22.8962H31.4671ZM36.3972 25.9301C36.7765 25.5509 36.7765 24.982 36.3972 24.6028C36.018 24.2236 35.4491 24.2236 35.0699 24.6028L34.2166 25.4561C31.4671 23.2754 27.6747 23.2754 24.9252 25.4561L24.0719 24.6028C23.6926 24.2236 23.1238 24.2236 22.7445 24.6028C22.3653 24.982 22.3653 25.5509 22.7445 25.9301L23.5978 26.7834C21.0379 30.1018 21.6068 34.8423 24.9252 37.4022C28.2435 39.9621 32.984 39.3932 35.5439 36.0748C37.7246 33.3253 37.7246 29.5329 35.5439 26.7834L36.3972 25.9301ZM29.5709 33.3253C28.528 33.3253 27.6747 32.472 27.6747 31.4291C27.6747 30.7655 28.0539 30.1018 28.6228 29.8174V27.6367C28.6228 27.0679 29.002 26.6886 29.5709 26.6886C30.1397 26.6886 30.519 27.0679 30.519 27.6367V29.8174C31.4671 30.2914 31.7515 31.4291 31.1826 32.3772C30.8034 32.9461 30.2345 33.3253 29.5709 33.3253Z",
    fill: "#4DA44E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveTime);
export default __webpack_public_path__ + "static/media/save-time.4eddada6df1a8632c77702baf89d3ee2.svg";
export { ForwardRef as ReactComponent };